import { type ComponentProps, memo } from 'react';
import { Fragment } from 'react/jsx-runtime';
import { Box, Text } from '@chakra-ui/react';

type InfoRow = { title: string; infos: string[] };

type Props = {
  infoRows: Array<InfoRow>;
  containerProps?: ComponentProps<typeof Box>;
};

const DebugAppVersionInfos = memo(({ infoRows, containerProps }: Props) => (
  <Box display='flex' flexDirection='column' alignItems='center' {...containerProps}>
    {infoRows.map(({ title, infos }) => (
      <Box key={title} display='flex' flexDirection='row' gap='.25rem'>
        <Text variant='small' color='neutral400' fontWeight='bold'>
          {title}
        </Text>
        {infos.map((info, i, a) => {
          const isLastItem = i === a.length - 1;
          return (
            <Fragment key={info}>
              <Text variant='small' color='neutral400'>
                {info}
              </Text>
              {!isLastItem && (
                <Text key={info} variant='small' color='neutral400'>
                  -
                </Text>
              )}
            </Fragment>
          );
        })}
      </Box>
    ))}
  </Box>
));

DebugAppVersionInfos.displayName = 'MemoDebugAppVersionInfos';

export { DebugAppVersionInfos };
